import { Link } from "react-router-dom"

export default function Testimonial(){
    return(
        <div>
            <section class="py-4 bg-white text-center">
                <p class="text-sm font-semibold tracking-widest text-yellow-600 uppercase mb-4">
                    Testimonial
                </p>
                <h2 class="text-3xl md:text-4xl font-fontMontserrat text-gray-900 mb-12">
                    Words From Clients
                </h2>

            <div class="grid gap-8 md:grid-cols-2 lg:grid-cols-4 max-w-7xl mx-auto px-6">
                <div class="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-yellow-600 mb-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M7.17 6A5.006 5.006 0 002 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5zm10 0A5.006 5.006 0 0012 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5z"/>
                    </svg>
                    <p class="text-base italic text-gray-600 mb-4">
                        From the staff to the Attorney–they carried themselves with so much professionalism.
                        Attorney Quilaton is very knowledgeable and responsive throughout the process. I’m
                        grateful for how they delivered my case and how everything turned out. Their skills and
                        commitment are very unique.
                    </p>
                    <p class="text-lg font-bold text-gray-900">Cherry Mae Elevazo</p>
                </div>

                <div class="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-yellow-600 mb-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M7.17 6A5.006 5.006 0 002 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5zm10 0A5.006 5.006 0 0012 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5z"/>
                    </svg>
                    <p class="text-base italic text-gray-600 mb-4">
                        Attorney Quilaton handled my case with urgency and respect and with that, the Office
                        earned my trust. Thank you for handling a sensitive case with care. I will keep coming
                        back and won’t hesitate to recommend your law firm to anyone.
                    </p>
                    <p class="text-lg font-bold text-gray-900">LJ Calaca</p>
                </div>

                <div class="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-yellow-600 mb-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M7.17 6A5.006 5.006 0 002 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5zm10 0A5.006 5.006 0 0012 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5z"/>
                    </svg>
                    <p class="text-base italic text-gray-600 mb-4">
                        The firm's communication was outstanding. They kept me informed every step of the way and responded quickly to my inquiries.
                    </p>
                    <p class="text-lg font-bold text-gray-900">Lorz Casinillo</p>
                </div>

                <div class="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-yellow-600 mb-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M7.17 6A5.006 5.006 0 002 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5zm10 0A5.006 5.006 0 0012 11v3c0 1.654 1.346 3 3 3h3a3 3 0 003-3v-3c0-2.757-2.243-5-5-5z"/>
                    </svg>
                    <p class="text-base italic text-gray-600 mb-4">
                        Professional, precise, and truly client-centered. Quilaton Law Office delivers not just legal solutions, but peace of mind. Highly commendable service!
                    </p>
                    <p class="text-lg font-bold text-gray-900">Liezl Gay Cawayan</p>
                </div>

            </div>
            </section>
        </div>
    )
}